import Resources from './resources';
import PortalCommunication from '../portal-comms';

const MESSAGE = {
    UNKNOWN: 'Something went wrong. Please try again.',
    INVALID_TOKEN: 'Invalid session. Please login and try again.'
};

class ErrorHandling {
    static addResourceResponseErrorInterceptor() {
        const interceptor = ErrorHandling.handleErrors;

        Resources.env.addResponseInterceptor(interceptor);
    }

    static handleErrors(result) {
        let message;
        let valid = false;

        try {
            switch (result.status) {
            case 200: case 201: case 204:
                valid = true;
                break;

            case 0: case 400: case 404: case 409: // bad request handle locally
                valid = true;
                break;

            case 401:
                message = MESSAGE.INVALID_TOKEN;
                break;

            default:
                message = result.message;
            }
        } catch (e) {
            message = MESSAGE.UNKNOWN;
        }

        // Global Error handling
        if (valid === false) {
            PortalCommunication.serverError(message);
        }

        // Pass Errors to Local actions to handle explicitly
        // when result.valid === true BUT
        // result contains result.message && result.code,
        // it means it requires to handle in async functions response
        result.valid = valid;

        return result;
    }
}

export default ErrorHandling;



// WEBPACK FOOTER //
// ./app/helpers/error-handling.js